import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
export function getCutHour(currentTime) {
  var hours = Math.floor(currentTime / (1000 * 60 * 60) % 24);
  return hours.toString().padStart(2, '0');
}
export function getCutMinute(currentTime) {
  var minutes = Math.floor(currentTime / (1000 * 60) % 60);
  return minutes.toString().padStart(2, '0');
}
export function getCutSecond(currentTime) {
  var seconds = Math.floor(currentTime / 1000 % 60);
  return seconds.toString().padStart(2, '0');
}
export function getHour(currentTime) {
  var hours = new Date(currentTime).getHours();
  return hours.toString().padStart(2, '0');
}
export function getMinute(currentTime) {
  var minutes = new Date(currentTime).getMinutes();
  return minutes.toString().padStart(2, '0');
}
export function getDayDifference(date) {
  var curDate = new Date(date);
  var now = new Date();
  var today = new Date("".concat(now.getFullYear(), "/").concat(now.getMonth() + 1, "/").concat(now.getDate()));
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  var dayAfterTomorrow = new Date(tomorrow);
  dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 1);
  var dayAfterTomorrowMore = new Date(dayAfterTomorrow);
  dayAfterTomorrowMore.setDate(dayAfterTomorrowMore.getDate() + 1);
  if (curDate >= today && curDate < tomorrow) {
    return {
      text: '今天',
      isDayAfterTomorrowMore: false
    };
  } else if (curDate >= tomorrow && curDate < dayAfterTomorrow) {
    return {
      text: '明天',
      isDayAfterTomorrowMore: false
    };
  } else if (curDate >= dayAfterTomorrow && curDate < dayAfterTomorrowMore) {
    return {
      text: '后天',
      isDayAfterTomorrowMore: false
    };
  } else {
    var month = curDate.getMonth() + 1;
    var day = curDate.getDate();
    return {
      text: "".concat(month, "\u6708").concat(day, "\u65E5 ").concat(getHour(date), ":").concat(getMinute(date)),
      isDayAfterTomorrowMore: true
    };
  }
}